import { connect } from 'react-redux'
import { hasUserRole } from '@layers-frontend/commons/store/selectors/user'
import PaymentWarningToast from '../../components/UIComponents/PaymentWarningToast'
import { USER_ROLES } from '@layers-frontend/commons/constants'

const mapStateToProps = state => ({
  hasRolePaywallPersistentWarning: hasUserRole(state, USER_ROLES.ROLE_PAYWALL_PERSISTENT_WARNING)
})

export default connect(mapStateToProps)(PaymentWarningToast)
